module.exports = __webpack_public_path__ + "static/noticias-12--981c5099703525da91f2932fb07f5281.jpg";